const actionTypes = {
    GET_EVENTS_BY_GROUP_REPORT_SUCCESS: 'GET_EVENTS_BY_GROUP_REPORT_SUCCESS',
};

export default actionTypes;